export default {
  NONE: "syncUpdateActions_NONE",
  IGNORE: "syncUpdateActions_IGNORE",
  APPLY_UPDATE: "syncUpdateActions_APPLY_UPDATE",
  APPLY_MOVE_TO_LOCAL: "syncUpdateActions_APPLY_MOVE_TO_LOCAL",
  APPLY_MOVE_TO_EXTERNAL: "syncUpdateActions_APPLY_MOVE_TO_EXTERNAL",
  APPLY_CREATE_TO_LOCAL: "syncUpdateActions_APPLY_CREATE_TO_LOCAL",
  APPLY_CREATE_TO_EXTERNAL: "syncUpdateActions_APPLY_CREATE_TO_EXTERNAL",
  APPLY_DELETE_TO_LOCAL: "syncUpdateActions_APPLY_DELETE_TO_LOCAL",
  APPLY_DELETE_TO_EXTERNAL: "syncUpdateActions_APPLY_DELETE_TO_EXTERNAL",
  APPLY_LOCAL_TO_EXTERNAL: "syncUpdateActions_APPLY_LOCAL_TO_EXTERNAL",
  APPLY_EXTERNAL_TO_LOCAL: "syncUpdateActions_APPLY_EXTERNAL_TO_LOCAL",
  UNRESOLVED: "syncUpdateActions_UNRESOLVED"
};
